import styled from 'styled-components';
import { black } from '../../global-styles';

const Content = styled.p`
  font-family: 'Source Sans Pro', sans-serif;
  font-size: 16px;
  line-height: 24px;
  font-weight: ${(props) => (props.bold ? 600 : 400)};
  color: ${(props) => (props.color ? props.color : black)};
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: ${(props) => (props.bold ? '.2px' : 'normal')};
  opacity: ${({ opacity }) => opacity || '1'};
`;

export default Content;
